<template>
    <div class="redirect-auth">
        <img src="../../public/img/loaders/Loader_Turquesa.gif" alt="" />
        <div class="preloader_images" v-for="src in img.srcs" :key="src.url">
            <image-preloader :srcs="img.path + src" @loaded-all="loadedAll" />
            <!-- <img :src="src"/> -->
        </div>
    </div>
</template>
<script>
var moment = require("moment");
moment.locale("pt-br");
import { Bus } from "../event-bus.js";
import i18n from "@/plugins/i18n";
import currentStepVerify from "../utils/currentStepVerify"
export default {
    data () {
        return{
            img: {
                isLoaded: false,
                arrayImgCount: 0,
                path: "../../img/icons/",
            }
        }
    },
    async created() {
        localStorage.clear();
        const { uid, token, workspaceId } = this.$route.query;
        let self = this;
        localStorage.setItem("workspaceId", workspaceId);
        await this.img.isLoaded;
        // this.changeLocale("pt-BR");
        try {
            const tokenReq = await this.$http.post(`${process.env.VUE_APP_HOST_FUNCTIONS}/verify?token=${token}`)
            // console.log("tokenReq POST: ", tokenReq)
        } catch (errorPOST) {
            //TODO: make a error message showing up instead console.log error
            // console.error("Error POST: ", errorPOST)
           try {
                const tokenReq = await this.$http.get(`${process.env.VUE_APP_HOST_FUNCTIONS}/users/verify-token-authentication?token=${token}`)
                // console.log("tokenReq GET: ", tokenReq)
           } catch (errorGET) {
                //TODO: make a error message showing up instead console.log error
            //    console.error("Error GET: ", errorGET)
               location.href = `${process.env.VUE_APP_HOST_AUTHENTICATION}/logout?workspaceId=${workspaceId}`;
           }
        }
        await this.getPlayer(uid, token);
        // console.log("before getWorkspace: ", workspaceId)
        await this.getWorkspace(workspaceId);
        await this.getGameSetId(uid, workspaceId);
    },
    methods: {
        async getGameSetId(uid, workspaceId) {
            try {
                const getGameSet = await this.$http.get(`${process.env.VUE_APP_HOST_FUNCTIONS_REPENSE}/game-sets?userId=${uid}&workspaceId=${workspaceId}`)
                if(!getGameSet.body.id){
                    this.$router.push('/statement-game')
                    return
                }
                this.buscaGame(getGameSet.body.id);
            } catch (error) {
                //TODO: make a error message showing up instead console.log error
                // console.log(error);
                if (error.body.response == "gameSet(s) not found") {
                    this.$router.push("/statement-game");
                    return;
                }
            }
        },
        buscaGame(gameSetId) {
            let self = this;
            this.$http.get(`${process.env.VUE_APP_HOST_FUNCTIONS_REPENSE}/solo-games/game-set-games?gameSetId=${gameSetId}`)
                .then(response => {
                    if(response.body.soloGames.length == 0){
                        this.$router.push('/statement-game')
                        return
                    }

                    if (response.body.soloGames.length > 4) {
                        self.$router.push("/dashboard");
                    } else {
                        let now = moment(response.body.now);
                        self.$store.commit("setNowState", now);

                        let lastSolo = self.defineLastSolo(
                            response.body.soloGames
                        );
                        let initGame = moment(lastSolo.createdAt);
                        let secondsDiff = initGame.diff(now, "seconds");
                        localStorage.setItem("soloGameId", lastSolo.id);
                        localStorage.setItem("secondsDiff", secondsDiff);
                        localStorage.setItem("gameSetId", gameSetId);
                        self.$store.commit(
                            "setSoloGameRequest",
                            response.body.soloGames
                        );
                        Bus.$emit("saveSoloGame", response.body.soloGames);
                        if (
                            response.body.soloGames.length == 4 &&
                            lastSolo.status != "inprogress"
                        ) {
                            self.$router.push("/dashboard");
                            return;
                        }
                        if (lastSolo.status == "inprogress") {
                            self.$router.push("/solo-game");
                            return;
                        }
                        if (
                            lastSolo.status == "timeout" ||
                            lastSolo.status == "hit" ||
                            lastSolo.status == "giveup"
                        ) {
                            localStorage.setItem("secondsDiff", "");
                            self.$router.push("/");
                            return;
                        }
                    }
                })
                .catch(error => {
                    //TODO: make a error message showing up instead console.log error
                    // console.log(error);
                });
        },
        defineLastSolo(soloGames) {
            if (soloGames.length < 2) return soloGames[0];
            let lastSolo = soloGames.reduce((a, b) => {
                return a.createdAt > b.createdAt ? a : b;
            });
            return lastSolo;
        },
        loadedAll(e) {
            this.img.arrayImgCount++;
            if (this.img.arrayImgCount == this.img.srcs.length) {
                this.img.isLoaded = true;
            }
        },
        async getPlayer(playerId, token) {
            const response = await this.$http.get(
                `${process.env.VUE_APP_HOST_FUNCTIONS}/users/${playerId}`
            );
            // console.log("response: ", response)
            let user = {
                name: response.body.name,
                email: response.body.email,
                uid: playerId,
                token,
                cpf: response.body.cpf
            };
            
            this.$store.dispatch("setPlayer", user);
            localStorage.setItem("uid", playerId);
            localStorage.setItem("user", JSON.stringify(user));
        },
        async getWorkspace(workspaceId) {
            const response = await this.$http.get(`${process.env.VUE_APP_SERVICE_CATALOG}/workspaces/${workspaceId}`);
            let wsLanguage = ''
            response.body.workspace.language ? wsLanguage = response.body.workspace.language : wsLanguage = 'pt-BR'
            localStorage.setItem("language", wsLanguage)
            // console.log(`ws language: `, wsLanguage)
            this.changeLocale(wsLanguage)
            localStorage.setItem("colors", JSON.stringify(await this.getCustomColors(workspaceId)));
            localStorage.setItem("workspaceTitle",response.data.workspace.title);            
        },
        async getCustomColors(workspaceId){
            // console.log("starting getCustomColors")
            // console.log("workspaceId: ", workspaceId)
            let colors = {
                primary: "#58fdf4",
                secondary: "#fe4778",
                theme: "dark",
                clientLogoPath: "",
                dark: {
                    to: "#192733",
                    from: "#001324",
                },
                light: {
                    to: "#ccc",
                    from: "#fff",
                },
            }
            try {
                // console.log("before get wsSetups")
                const responseSetups = await this.$http.get(`${process.env.VUE_APP_SERVICE_CATALOG}/ws-setups/?workspaceId=${workspaceId}`);
                // console.log("responseSetups: ", responseSetups)
                if (!responseSetups.body.wsSetups.fields || !responseSetups.body.wsSetups.fields.products || !responseSetups.body.wsSetups.fields.products.repense) return colors
                if (responseSetups.body.wsSetups.fields.products.repense.colors)
                    colors = {
                        ...colors, 
                        ...responseSetups.body.wsSetups.fields.products.repense.colors,
                        theme: responseSetups.body.wsSetups.fields.products.repense.theme || 'dark',
                        clientLogoPath: responseSetups.body.wsSetups.fields.products.repense.logoPath
                    }
            } catch (error) {
                return colors
            }
            return colors
        },
        changeLocale(locale) { i18n.locale = locale; }
    }
};
</script>
<style lang="scss" scoped>
.redirect-auth {
    height: 100%;
    width: 100%;
    flex-direction: column;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #404040;

    .preloader_images {
        visibility: hidden;
    }

    img {
        height: 120px;
    }
}
</style>